export default __webpack_public_path__ + "static/media/t-5.1336f373.jpg";